<template>
    <el-option 
    :title="label" 
    :label="label | titleLimit" 
    :value="value"
    >
    </el-option>
</template>

<script>
    export default {
        props:{
            label:{
                type:String,
            },
            value:{
                type:[String,Number],
            },
        }
    }
</script>




// WEBPACK FOOTER //
// limitOption.vue?79d17706